export const NAME = 'installer-profile';
